import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Box, Button, Card, CardContent, FormControlLabel, Grid, IconButton, Radio, TableCell, TableRow, Typography } from "@deere/fuel-react";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../components/CustomAlert";
import CampaignClosedAlert from "../../components/CampaignClosedAlert";
import { ModalGeneric } from "../../components/ModalGeneric";
import { SVGIconDelete } from "../../components/SVGIcon";
import SurveyTitle from "../../components/SurveyTitle";
import { deleteResponseByResponseIdSurveypart, getResponseByIdSurveypart, getResponsesByAssignmentSurveypart, getAllSurveyPartsRequestedByAssignment } from "../../services/surveypart.service";
import { SURVEY_RESPONSE_STATUSES, SCBM_STATES_CAMPAIGN, DEFAULT_LANGUAGE, SURVEYPART_SECTION_TYPES, QUESTION_TYPES } from "../../utils/surveyLiterals";
import { dateConvert } from "../../utils/utils";
import SectionPage from "./SectionPage";
import DisclaimerBox from "../../components/DisclaimerBox";
import ButtonSection from "./ButtonSection";
import { getHelpDocPdfBySurveyId } from "../../services/surveyHelpDoc.service";
import cookie from "js-cookie";
import { PartPopUp } from "./PartPopUpViewOnly";


export const SurveyPage = ({ survey, setSurvey, campaignAssigned, literals, setLiterals, isAuthMethodOkta, token, surveyLanguages, disclaimerPosition }) => {
  const history = useHistory();
  const sections = survey.sections;
  let sectionsTitles = [...sections.map((section) => section.description)];
  const sectionsRef = useRef([new Array(sectionsTitles.length)]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [validated, setValidated] = useState(false);
  const [errorCard, setErrorCard] = useState([]);
  const [successMessage, setSuccessMessage] = useState(undefined);
  const [surveyPartResponses, setSurveyPartResponse] = useState(undefined);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [transactionParts, setTransactionParts] = useState([]);
  const [partErrorIds, setPartErrorIds] = useState([]);
  const [submitResponse, setSubmitResponse]=useState(false)
  const [saveButtonClickFlag, setSaveButtonClickFlag] = useState(false); //Using to Stop Historical Data API call on Save click
  const { t } = useTranslation();
  const form = document.forms.surveyPartForm;
  let questionsToValidate;


  const [surveyData, setSurveyData] = useState({
    suppliers: [],
    answers: [],
    campaignId: campaignAssigned && campaignAssigned.id ? campaignAssigned.id : null,
    responseName: null,
    partAnswers: [],
    responseId: null,
    parts: [],
    assignments: [],
    totalReqestedParts : campaignAssigned && campaignAssigned.totalReqParts ? campaignAssigned.totalReqParts : 0
  });

  const [showValidationModal, setShowValidationModal] = useState(false);
  const [opcTodelete, setOpcTodelete] = useState(null);
  const [opcSelected, setOpcSelected] = useState(null);
  const [deleteResponseMessage, setdeleteResponseMessage] = useState(null);
  const [editedPart, setEditedPart] = useState([]);
  const [url, setUrl] = useState(null);
  
  const [rnSelected, setRnSelected] = useState(undefined);
  const [showParts, setShowParts] = useState(false);


  function clearErrors() {
    setValidated(false);
    setErrorCard([]);
    setSuccessMessage(undefined);
  }

  function review(responseId, newSurveyData) {
    history.push({
      pathname: isAuthMethodOkta ? '/surveypart/review' : '/surveypartext/review',
      state: {
        previous: "/surveypart",
        assignmentId: campaignAssigned.assignments[0].id,
        responseId: responseId,
        survey: survey,
        surveyData: newSurveyData,
        isAuthNonOkta : !isAuthMethodOkta,
        literals: literals,
        disclaimerPosition: disclaimerPosition,
      },
    });
  }

  const resetForm = (newSurveyData) => {
    setSubmitResponse(false)
    setEditedPart([]);
    setSelectionModel([]);
    setOpcSelected(null);
    setTransactionParts([]);
    setPartErrorIds([]);
    newSurveyData
      ? setSurveyData(newSurveyData)
      : setSurveyData((prevState) => {
          return { ...prevState, suppliers: [], answers: [], partAnswers: [], responseId: null, responseName: null, parts: [], assignments: [] };
        });
  };

  const deleteResponse = () => {
    try {
      deleteResponseByResponseIdSurveypart(opcTodelete, token, campaignAssigned.isNonDeere, isAuthMethodOkta).then((response) => {
        if (response && response.numberResponsesDeleted && response.numberResponsesDeleted > 0) {
          getResponsesByAssignmentSurveypart(campaignAssigned.assignments[0].id, token, campaignAssigned.isNonDeere, isAuthMethodOkta).then((response) => {
            if (response) {
              setSurveyPartResponse(response);
            }
          });
          resetForm();
          setSuccessMessage(t("coo_msg_success_delete"));
        } else {
          setErrorCard(t("coo_msg_response_not_found"));
          window.scrollTo(0, 0);
        }
        setShowValidationModal(false);
      });
    } catch (error) {
      console.log(error);
      setShowValidationModal(false);
      setErrorCard(t("coo_msg_response_not_found"));
      window.scrollTo(0, 0);
    }
  };
  
  useEffect(()=>{
    if(survey && survey.code){
        getHelpDocPdfBySurveyId(token, survey.id, (cookie.get("i18next") || DEFAULT_LANGUAGE), isAuthMethodOkta).then(async (response) => {
            if(response.status === 200){
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                setUrl(url);
            }
        })
        .catch((err) => {
           console.log(err);
        });
    }
  }, []);

  function setResponseSelected(e, response, goToReviewPage) {
    if(!goToReviewPage && response.status===SURVEY_RESPONSE_STATUSES.SUBMITTED){
      setSubmitResponse(true)
    }
    const questionTypes = survey.sections.flatMap(section => section.questions.map(question => ({ questionId: question.id, questionType: question.type })));
    getResponseByIdSurveypart(response.id, token, campaignAssigned.isNonDeere, isAuthMethodOkta)
      .then((res) => {
        if(e && e.target && e.target.value){
          setOpcSelected(e.target.value);
        } 
        res.answers.forEach((ans) => {
          const index = questionTypes.findIndex((q) => q.questionId === ans.questionId);
          if (index > -1 && questionTypes[index].questionType === QUESTION_TYPES.FILE) {
            ans.answer = ans?.multiAnswer?.join(", ");
          }
          delete ans.multiAnswer;
        });
        const newSurveyData = {
          suppliers: res.assignments.length > 0 ? res.assignments.map((it) => it.supplierNumber) : [],
          answers: res.answers,
          responseName: res.responseName,
          responseId: res.id,
          partAnswers: res.partAnswers,
          campaignId: surveyData.campaignId,
          answers: res.answers,
          parts: res.parts,
          assignments: res.assignments,
          totalReqestedParts: surveyData.totalReqestedParts
        };
        resetForm(newSurveyData);
        if (goToReviewPage) {
          review(response.id, newSurveyData);
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorCard(t("tps_msg_response_not_found"));
        resetForm();
      });
  }

  const popUpPartsLink = (row, values) => {
    return <a href='#' onClick={e => {
        e.preventDefault();
        setRnSelected(row.campaignAssignmentId);
        setShowParts(true);
    }
    } >{values}</a>
  }

  function closePartWindow(deletedParts) {
    setShowParts(false);
  }

  function getTableRows(data) {
    if (data) {
      return data.map((row, index) => (
        <TableRow key={index}>
          <TableCell>
            <FormControlLabel
              control={<Radio name="responseSelected" id="responseSelected" value={row.id} checked={surveyData.responseId === row.id ? true : false} />}
              label=""
              onChange={(e) => setResponseSelected(e, row, false)}
            />
          </TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>
            {row.status === SURVEY_RESPONSE_STATUSES.SUBMITTED ? (
              <Button
                variant="text"
                onClick={(e) => {
                  setResponseSelected(e, row, true);
                }}
              >
                {row.responseName}
              </Button>
            ) : (
              row.responseName
            )}
          </TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>{popUpPartsLink(row,surveyData.totalReqestedParts)}</TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>{row.numberOfParts}</TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>{dateConvert(row.lastUpdatedTs)}</TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>{row.updatedBy}</TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>{row.status}</TableCell>
          <TableCell sx={{fontSize: "12px!important"}}>
            <IconButton
              aria-label="delete"
              onClick={(e) => {
                setOpcTodelete(row.id);
                buildModalMessage(row);
                setShowValidationModal(true);
              }}
              disabled={disableDeleteIcon()}
            >
              <SVGIconDelete />
            </IconButton>
          </TableCell>
        </TableRow>
      ));
    } else {
      return null;
    }
  }

  const isCampaignClosed = campaignAssigned && campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED;

  function disableDeleteIcon() {
    return isCampaignClosed;
  }

  function getLastResponse(data) {
    if (data) {
      const tmpArray = [...data];
      tmpArray.sort(function (a, b) {
        return new Date(b.lastUpdatedTs) - new Date(a.lastUpdatedTs);
      });
      return tmpArray[0];
    } else {
      return null;
    }
  }

  useEffect(() => {
    const assigmentId = campaignAssigned && campaignAssigned.assignments[0] ? campaignAssigned.assignments[0].id : null;
    if (assigmentId) {
      getResponsesByAssignmentSurveypart(assigmentId, token, campaignAssigned.isNonDeere, isAuthMethodOkta).then((response) => {
        if (response) {
          setSurveyPartResponse(response);
        }
      });
    }
  }, [token, campaignAssigned]);

  const buildModalMessage = (response) => {
    const { assignments } = campaignAssigned;
    const supplierNumber = assignments.filter((assignment) => assignment.id === response.campaignAssignmentId);
    const message = `${t("coo_msg_delete_response")}\n ${t("coo_msg_delete_response_number", {
      responseName: response.responseName ? response.responseName : "",
      supplierNumber: supplierNumber[0].supplierNumber,
    })}`;
    setdeleteResponseMessage(message);
  };

  const updateSuppliersArray = (array) => {
    if (Array.isArray(array)) {
      setSurveyData((prevState) => {
        return { ...prevState, suppliers: [...array.map((i) => i.supplierNumber)], assignments: [...array] };
      });
    }
  };

  const pushResponseName = (newResponseName) => {
    setSurveyData((prevState) => {
      return { ...prevState, responseName: newResponseName };
    });
  };

  const updatePartsArray = (partsArray) => {
    setSurveyData((prevState) => {
      return { ...prevState, partAnswers: partsArray};
    });
  };

  const pushAnswer = (questionId, answer, answersToDelete) => {
    let finalContextAnswers = surveyData.answers ? [...surveyData.answers] : [];
    let childQuestions = [];
    const ans = { questionId, answer: answer };
    if (answersToDelete && answersToDelete.length > 0) {
      childQuestions = answersToDelete.filter((child) => child.idQuestionDepends === questionId);
    }
    if (childQuestions && childQuestions.length > 0) {
      finalContextAnswers = finalContextAnswers.filter((ans) => !childQuestions.some((childQ) => ans.questionId === childQ.id));
    }
    const tmpId = finalContextAnswers ? finalContextAnswers.findIndex((a) => parseInt(a.questionId) === parseInt(questionId)) : -1;
    if (tmpId >= 0) {
      if (ans && ans.answer.length > 0) {
        finalContextAnswers[tmpId] = ans;
        setSurveyData({ ...surveyData, answers: [...finalContextAnswers] });
      } else {
        popAnswer(questionId);
      }
    } else {
      setSurveyData({ ...surveyData, answers: Array.isArray(finalContextAnswers) ? [...finalContextAnswers, ans] : [ans] });
    }
  };

  const popAnswer = (questionId) => {
    const newAns = Array.isArray(surveyData.answers) ? surveyData.answers.filter((a) => a.questionId !== questionId) : [surveyData.answers];
    setSurveyData({
      ...surveyData,
      answers: newAns,
    });
  };

  const showErrorCard = (
    <>
      <Card className="p-2 mb-2 bg-danger">
        <CardContent className="uxf-card-body-table">
          <Typography className="pb-3 text-white">{!(errorCard && errorCard.length > 0 && errorCard[0].includes("saving")) ? t("lbl_error_survey_validation") : ""}</Typography>
          {errorCard.map((error, index) => (
            <div key={index}>
              <li className="text-white">{error}</li>
            </div>
          ))}
        </CardContent>
      </Card>
      <br />
    </>
  );
  
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={getLastResponse(surveyPartResponses)} endDate={campaignAssigned.endDate} />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ pt:2, pb:2}}>
            {errorCard.length > 0 ? showErrorCard : null}
            {successMessage ? <CustomAlert accessibilityLabel="success" variant="success" title={successMessage} /> : null}
            <CampaignClosedAlert campaign={campaignAssigned}/>
          </Box>
          {(survey && survey.code && literals.length > 0 ) && <DisclaimerBox literals={literals} surveyCode={survey.code} disclaimerPosition={disclaimerPosition}/>}
          <form noValidate validated={validated.toString()} id="surveyPartForm">
            <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
            {sections
             .filter((section)=>section.type!==SURVEYPART_SECTION_TYPES.ADMIN_COMMENTS)
              .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
              .map((section, index) => (
                <div key={index} ref={(el) => (sectionsRef.current[index] = el)}>
                  <SectionPage
                    surveyData={surveyData}
                    section={section}
                    survey={survey}
                    review={isCampaignClosed}
                    campaign={campaignAssigned}
                    surveyPartResponses={getTableRows(surveyPartResponses)}
                    isSubmit={isSubmitted}
                    setIsSubmitted={setIsSubmitted}
                    resetForm={resetForm}
                    opcSelected={opcSelected}
                    pushResponseName={pushResponseName}
                    updatePartsArray={updatePartsArray}
                    updateSuppliersArray={updateSuppliersArray}
                    selectionModel={selectionModel}
                    setSelectionModel={setSelectionModel}
                    questionsToValidate={questionsToValidate}
                    pushAnswer={pushAnswer}
                    popAnswer={popAnswer}
                    surveyForm={form}
                    editedPart={editedPart}
                    setEditedPart={setEditedPart}
                    setTransactionParts={setTransactionParts}
                    transactionParts={transactionParts}
                    partErrorIds={partErrorIds}
                    setPartErrorIds={setPartErrorIds}
                    url={url}
                    isAuthMethodOkta={isAuthMethodOkta}
                    token={token}
                    literals={literals}
                    saveButtonClickFlag={saveButtonClickFlag}
                    setSaveButtonClickFlag={setSaveButtonClickFlag}
                    uploadedFiles={uploadedFiles} 
                    setUploadedFiles={setUploadedFiles}
                  />
                </div>
              ))}
            </fieldset>
            <ButtonSection
              disabled={isCampaignClosed}
              surveyData={surveyData}
              setSurveyPartResponse={setSurveyPartResponse}
              campaign={campaignAssigned}
              setSurvey={setSurvey}
              setLiterals={setLiterals}
              clearFunction={clearErrors}
              setIsSubmitted={setIsSubmitted}
              sections={sections}
              errorCard={errorCard}
              setErrorCard={setErrorCard}
              setValidated={setValidated}
              surveyForm={form}
              setSuccessMessage={setSuccessMessage}
              setUrl={setUrl}
              url={url}
              setPartErrorIds={setPartErrorIds}
              setResponseSelected={setResponseSelected}
              isAuthMethodOkta={isAuthMethodOkta}
              token={token}
              submitResponse={submitResponse}
              setSaveButtonClickFlag={setSaveButtonClickFlag}
              surveyLanguages={surveyLanguages}
              uploadedFiles={uploadedFiles}
              survey={survey}
            />
          </form>
        </Grid>
      </Grid>
      <ModalGeneric
        showModal={showValidationModal}
        setShowModal={setShowValidationModal}
        labelBtnPrimary={t("t2_remove")}
        labelBtnSecondary={t("btn_cancel")}
        handleSubmit={deleteResponse}
        msgModal={deleteResponseMessage}
        titleModal={t("t2_remove")}
      />
      {
        showParts ? <PartPopUp show={showParts} handleClose={closePartWindow} assignmentId={rnSelected} campaign={campaignAssigned} partFunc={getAllSurveyPartsRequestedByAssignment} survey={survey} isAuthMethodOkta={isAuthMethodOkta} token={token} defaultColumns={survey.defaultColumns}></PartPopUp> : null
      }
    </>
  );
};
